<div #field class="selector-field" woa-activatable (onActivate)="control.activate($event)">
    <div class="selector-field-body">
        <woa-selector-control #control [label]="label()" [translationParams]="translationParams()"
                              [type]="SelectorType.RADIO" [disabled]="disabled()"
                              [selected]="selected()"
                              (selectedChange)="selectedChange.emit($event)"
                              (onSelect)="onActivateLabel.emit()"></woa-selector-control>
        <div class="selector-field-body-decorator">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="selector-field-action">
        <ng-content select="[slot=action]"></ng-content>
    </div>
    @if (message()) {
        <div class="selector-field-message">
            {{ message() | translate: translationParams() }}
        </div>
    }
    <div class="selector-field-details" [class.hidden]="!selected()">
        <ng-content select="[slot=details]"></ng-content>
    </div>
</div>
